var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseLayout', {
    staticClass: "px-0",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('v-icon', {
          attrs: {
            "left": ""
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: _vm.DashboardRouteNames.Home
              });
            }
          }
        }, [_vm._v("mdi-arrow-left")]), _vm._v(" Kurs med lavt fremmøte ")];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mr-5",
          attrs: {
            "append-icon": "mdi-magnify",
            "label": "Søk i kurs",
            "single-line": "",
            "hide-details": ""
          },
          model: {
            value: _vm.search,
            callback: function callback($$v) {
              _vm.search = $$v;
            },
            expression: "search"
          }
        })];
      },
      proxy: true
    }])
  }, [[_c('BaseTableFiltered', {
    staticClass: "mt-3",
    attrs: {
      "item-key": "courseId",
      "headers": _vm.headers,
      "items": _vm.coursesWithLowAttendance,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "item.courseParticipantsWithLowAttendance",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _vm._l(item.courseParticipantsWithLowAttendance, function (participantId, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "mr-3",
            attrs: {
              "label": ""
            },
            on: {
              "click": function click($event) {
                return _vm.navigateToParticipantAttendance(item.courseId, participantId);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.getParticipantName(participantId)) + " ")]);
        });
      }
    }, {
      key: "actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                  attrs = _ref3.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "displayCourseAttendance-".concat(item.id)
                },
                on: {
                  "click": function click($event) {
                    return _vm.displayCourseAttendance(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-open-in-new")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Vis fremmøte")])])];
      }
    }], null, true)
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }